module.exports = __webpack_public_path__ + "static/media/HUSD-USDT.f58288c9.svg";